import React from "react";
import { FaBriefcase } from "react-icons/fa";
import profile from "../../data/profile";

function Experience() {
  return (
    <section className="glass-card">
      <h2 className="section-title">
        <FaBriefcase /> Professional Experience
      </h2>
      <div className="timeline-container">
        {profile.experience.map((job, i) => (
          <div className="timeline-item" key={i}>
            <div className="timeline-dot"></div>
            <span className="time-badge">{job.period}</span>
            <h3>{job.role}</h3>
            <div className="company">{job.company}</div>
            <div className="context">{job.context}</div>
            <ul className="timeline-list">
              {job.points.map((point, j) => (
                <li key={j}>{point}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Experience;